import { Routes, Route, Navigate } from "react-router-dom";
import globalStyles from "./App.module.css";
import BoardContainer from "./components/BoardContainer";
import { AuthProvider } from "./components/Providers/AuthContext";
import { GameContextProvider } from "./components/Providers/GameContext";
import { ThemeProvider } from "./components/Providers/ThemeContext";
import { LanguageProvider } from "./components/Providers/LanguageContext";
import Tutorials from "./components/Tutorials/Tutorials";
import TutorialGame from "./components/Tutorials/TutorialGame";
import TutorialDevPage from "./components/Tutorials/TutorialDevPage";
import MainPage from "./components/MainPage/MainPage";
import ChallengeAI from "./components/ChallengeAI/ChallengeAI";
import PieceRules from "./components/PieceRules/PieceRules";
import Sandbox from "./components/Sandbox/Sandbox";
import Puzzles from "./components/Puzzles/Puzzles";
import WhatsMyZodiac from "./components/WhatsMyZodiac/WhatsMyZodiac";
import Multiplayer from "./components/Multiplayer/Multiplayer";
import StripeSuccess from "./components/StripeSuccess/StripeSuccess";
import StripeError from "./components/StripeError/StripeError";
import History from "./components/History/History";
import Analytics from "./components/Analytics/Analytics";
import Courses from "./components/Courses/Courses";
import Shop from "./components/Shop/Shop";
import Collection from "./components/Collection/Collection";
import { PrivacyPolicy } from "./components/PrivacyPolicy/PrivacyPolicy";
import { TermsOfService } from "./components/TermsOfService/TermsOfService";
import { CookiePolicy } from "./components/CookiePolicy/CookiePolicy";
import { CookieConsent } from "./components/CookieConsent/CookieConsent";
import TestingPage from "./components/TestingPage/TestingPage";
import PageDesign from "./components/PageDesign/PageDesign";
import DevNavigation from "./components/DevNavigation/DevNavigation";
import Leaderboard from "./components/Leaderboard/Leaderboard";
import AIArena from "./components/AIArena/AIArena";
import PuzzleDesigner from "./components/PuzzleDesigner/PuzzleDesigner";
import BugReports from "./components/BugReports/BugReports";
import DevProtectedRoute from "./components/DevProtectedRoute/DevProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { FriendsProvider } from "./components/Providers/FriendsContext";
import FriendsSidebar from "./components/FriendsSidebar/FriendsSidebar";
import SharedSandbox from "./components/SharedSandbox/SharedSandbox";

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <div className={globalStyles.app}>
          <AuthProvider>
            <FriendsProvider>
            <GameContextProvider>
            {/* Cookie Consent Banner - shows on all pages */}
            <CookieConsent />
            <FriendsSidebar />
            <ErrorBoundary>
            <Routes>
              <Route path="/" element={<Navigate to="/main" replace />} />
              <Route path="/main" element={<MainPage />} />
              {/* HowToPlay removed - functionality now in MainPage */}
              <Route path="/tutorials" element={<Tutorials />} />
              <Route path="/tutorial-dev" element={<DevProtectedRoute><TutorialDevPage /></DevProtectedRoute>} />
              <Route path="/challenge-ai" element={<ChallengeAI />} />
              <Route path="/multiplayer" element={<Multiplayer />} />
              <Route path="/piecerules" element={<PieceRules />} />
              <Route path="/sandbox" element={<Sandbox />} />
              <Route path="/shared-sandbox/:sessionId" element={<SharedSandbox />} />
              <Route path="/puzzles" element={<Puzzles />} />
              <Route path="/whats-my-zodiac" element={<WhatsMyZodiac />} />
              <Route path="/stripe-success" element={<StripeSuccess />} />
              <Route path="/success" element={<StripeSuccess />} />
              <Route path="/error" element={<StripeError />} />
              <Route path="/history" element={<DevProtectedRoute><History /></DevProtectedRoute>} />
              <Route path="/analytics" element={<DevProtectedRoute><Analytics /></DevProtectedRoute>} />
              <Route path="/courses" element={<DevProtectedRoute><Courses /></DevProtectedRoute>} />
              <Route path="/shop" element={<DevProtectedRoute><Shop /></DevProtectedRoute>} />
              <Route path="/collection" element={<DevProtectedRoute><Collection /></DevProtectedRoute>} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/testing" element={<DevProtectedRoute><TestingPage /></DevProtectedRoute>} />
              <Route path="/pagedesign" element={<DevProtectedRoute><PageDesign /></DevProtectedRoute>} />
              <Route path="/tutorials/:constellation/:tutorialIndex" element={<TutorialGame />} />
              <Route path="/game" element={<DevProtectedRoute><DevNavigation /></DevProtectedRoute>} />
              <Route path="/ai-arena" element={<DevProtectedRoute><AIArena /></DevProtectedRoute>} />
              <Route path="/puzzle-designer" element={<DevProtectedRoute><PuzzleDesigner /></DevProtectedRoute>} />
              <Route path="/leaderboard" element={<DevProtectedRoute><Leaderboard /></DevProtectedRoute>} />
              <Route path="/bug-reports" element={<DevProtectedRoute><BugReports /></DevProtectedRoute>} />
              <Route path="/:navGameId?" element={<BoardContainer />} />
            </Routes>
            </ErrorBoundary>
          </GameContextProvider>
            </FriendsProvider>
        </AuthProvider>
      </div>
    </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
